import { FareClassEnum } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";

export const FARE_CLASS_I18N_KEY = {
  basic: "fareClass.basicLabel",
  standard: "fareClass.standardLabel",
  enhanced: "fareClass.enhancedLabel",
  premium: "fareClass.premiumLabel",
  luxury: "fareClass.luxuryLabel",
};

export interface IFareClassOption {
  label: string;
  value: FareClassEnum;
}

export const useFareClassOptions = () => {
  const { t } = useI18nContext();

  const fareClassOptions: IFareClassOption[] = [
    {
      label: t("fareClass.basicLabel"),
      value: FareClassEnum.basic,
    },
    {
      label: t("fareClass.standardLabel"),
      value: FareClassEnum.standard,
    },
    {
      label: t("fareClass.enhancedLabel"),
      value: FareClassEnum.enhanced,
    },
    {
      label: t("fareClass.premiumLabel"),
      value: FareClassEnum.premium,
    },
    {
      label: t("fareClass.luxuryLabel"),
      value: FareClassEnum.luxury,
    },
  ];

  return {
    context: { fareClassOptions },
  };
};
